<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      salvando: {
        type: Boolean,
        default: false,
      },
      detalhe: {
        type: Object,
        default: null,
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
      liberarTodos() {
        return !!(this.detalhe && this.detalhe.liberarTodos);
      },
      quantidade() {
        return (this.detalhe && this.detalhe.quantidadeLiberar) || 0;
      },
      texto() {
        if (!this.liberarTodos) {
          return 'Deseja liberar o pagamento deste rateio?';
        }

        if (this.quantidade > 1) {
          return `Você está liberando todos os ${this.quantidade} rateios pendentes deste lançamento nos seus projetos. Confirma?`;
        }

        return 'Você está liberando todos os rateios pendentes deste lançamento nos seus projetos. Confirma?';
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           :backdrop="false">
      <div slot="modal-header" class="modal-header hide"></div>

      <div class="swal2-icon swal2-question" style="display: block;">?</div>

      <h3 class="text-center">{{ texto }}</h3>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" :disabled="salvando" @click="$emit('liberar')">
          <i class="fa fa-check"></i> Liberar
        </button>
        <button type="button" class="btn btn-default" :disabled="salvando" @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pagamento/componentes/ModalConfirmarLiberacao.vue